'use client';
import React from 'react';
import { Button, Link } from '@skin-seoul/design-system';

interface LoyaltySignUpBannerMobileProps {
  titleLine2?: string;
}

export const LoyaltySignUpBannerMobile = ({ titleLine2 = 'SkinSociety' }: LoyaltySignUpBannerMobileProps) => {
  return (
    <div
      className="relative w-full h-[112px] rounded-[12px] overflow-hidden"
      style={{ background: 'linear-gradient(to top left, #311275, #754DCC)' }}
    >
      <div className="relative h-full flex items-center justify-between px-4 z-[1]">
        {/* Left Side - Title */}
        <div className="flex flex-col gap-0">
          <p className="text-primary-100 text-heading-h6-mobile font-bold">Join</p>
          <p className="text-primary-100 text-heading-h6-mobile font-bold">{titleLine2}</p>
        </div>

        {/* Right Side - Sign Up Button */}
        <Button
          className="h-[40px] bg-white text-neutral-800 px-4 hover:bg-neutral-50"
          asChild
          size="sm"
          variant="primary"
        >
          <Link href="/my-account/">Sign Up</Link>
        </Button>
      </div>
    </div>
  );
};
